<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="Etkinlik_detay">
        <AppMain>





            <div class="nk-content ">
        <div class="container-fluid">
            <div class="nk-content-inner">
                <div class="nk-content-body">
                    <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">

                            

                                <h3 class="nk-block-title page-title">Etkinlik  / <strong class="text-primary small">{{ etkinlikler.ad }}</strong></h3>
                                <div class="nk-block-des text-soft">
                                    <ul class="list-inline">
                                        <li>Etkinlik  ID: <span class="text-base">{{ etkinlikler.id }}</span></li>
                                        <li>Güncelleme Tarihi: <span class="text-base">{{ etkinlikler.duzenleme_tarih }}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="nk-block-head-content">
                                <router-link to="/etkinlikler"  class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                        class="icon ni ni-arrow-left"></em><span>Etkinlikler</span>
                                    </router-link>
                                  </div>
                        </div>
                    </div>
                    <div class="nk-block">
                        <div class="card card-bordered">
                            <div class="card-aside-wrap">
                                <div class="card-content">
                                    <ul class="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                                        
                                        <li class="nav-item">
                                            <a  href="#" :class="{ 'active': aktifSekme === 'bilgiler','nav-link':true}"
                                            @click="aktifSekmeDegistir('bilgiler')">
                                                <em class="icon ni ni-user-circle"></em>
                                                <span>Etkinlik Bilgileri</span>
                                            </a>
                                        </li>

                                        

                                        
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'firmalar','nav-link':true}"
                                                    @click="aktifSekmeDegistir('firmalar')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Firmalar</span>
                                                    </a>
                                                </li>
                                    
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'kisiler','nav-link':true}"
                                                    @click="aktifSekmeDegistir('kisiler')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Kişiler</span>
                                                    </a>
                                                </li>
                                    
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'gorusmebilgiler','nav-link':true}"
                                                    @click="aktifSekmeDegistir('gorusmebilgiler')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Görüşme Bilgiler</span>
                                                    </a>
                                                </li>
                                    


                                        
                                   
                                        

                                     
                                        
                                     
                                        <li class="nav-item nav-item-trigger d-xxl-none">
                                            <a href="#" class="toggle btn btn-icon btn-trigger" data-target="userAside">
                                            <em class="icon ni ni-user-list-fill"></em></a>
                                        </li>
                                    </ul>

                               
                                    <div class="card-inner" v-show="aktifSekme === 'bilgiler'">
                                        <div class="nk-block">
                                            <div class="nk-block-head">
                                                <h5 class="title">Etkinlik Bilgileri</h5>
                                               
                                            </div>
                                            <div class="profile-ud-list">
                                                


                                                
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ad </span><span class="profile-ud-value">{{ etkinlikler.ad }}</span></div>
                                                                </div>
                                    
                                    

                                    
                               
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Başlama Tarihi </span><span class="profile-ud-value">{{ etkinlikler.bastarih }}</span></div>
                                                                </div>
                                    
                               
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Bitiş Tarihi </span><span class="profile-ud-value">{{ etkinlikler.bittarih }}</span></div>
                                                                </div>
                                    
                                                 
                                                 
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Logo</span><span class="profile-ud-value">     <img 
    
                                                                    class="rounded img-cover mb-2 h-50" 
                                                                    :src="$globalVariable.uploadUrl + etkinlikler.logo" 
                                                                /></span></div>
                                                                </div>   

                                            </div>
                                        </div>
                                        <div class="nk-block">
                                            <div class="nk-block-head nk-block-head-line">
                                                <h6 class="title overline-title text-base">Kayıt Bilgileri</h6>
                                            </div>
                                            <div class="profile-ud-list">
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Oluşturma Tarihi</span><span class="profile-ud-value">{{ etkinlikler.olusturma_tarih }}</span></div>
                                                </div>
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Son Düzenleme Tarihi</span><span class="profile-ud-value">{{ etkinlikler.duzenleme_tarih }}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="nk-divider divider md"></div>
                                      
                                    </div>
                                    

                                    
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'firmalar'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Firmalar</h6>
                                                    <a  @click="firmalar_ekle" class="btn btn-primary" >
                                                        <span>Firma Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <firmaCard :firmalar="firmalar" :duzenle="firmalar_duzenle"   :detay="firmalar_duzenle"    :formKaydetSonrasi="etkinliklerDetayGetir"  @update:firmalar="firmalarGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="firmalar.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="firmalar.islem == 'ekle'"> Yeni Firma Ekle </h5>
                                                    <h5 class="modal-title" v-if="firmalar.islem == 'duzenle'">Firma Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="firmalar_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <firmaForm :formIslem="firmalar.islem" :formData="firmalar.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="firmalar_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'kisiler'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Kişiler</h6>
                                                    <a  @click="kisiler_ekle" class="btn btn-primary" >
                                                        <span>Kişi Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <kisiCard :kisiler="kisiler" :duzenle="kisiler_duzenle"  :detay="kisiler_duzenle"     :formKaydetSonrasi="etkinliklerDetayGetir"  @update:kisiler="kisilerGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="kisiler.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="kisiler.islem == 'ekle'"> Yeni Kişi Ekle </h5>
                                                    <h5 class="modal-title" v-if="kisiler.islem == 'duzenle'">Kişi Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="kisiler_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <kisiForm :formIslem="kisiler.islem" :formData="kisiler.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="kisiler_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'gorusmebilgiler'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Görüşme Bilgiler</h6>
                                                    <a  @click="gorusmebilgiler_ekle" class="btn btn-primary" >
                                                        <span>Görüşme Bilgi Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <gorusmebilgiCard :gorusmebilgiler="gorusmebilgiler" :duzenle="gorusmebilgiler_duzenle" :detay="gorusmebilgiler_duzenle"    :formKaydetSonrasi="etkinliklerDetayGetir"  @update:gorusmebilgiler="gorusmebilgilerGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="gorusmebilgiler.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'ekle'"> Yeni Görüşme Bilgi Ekle </h5>
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'duzenle'">Görüşme Bilgi Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="gorusmebilgiler_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <gorusmebilgiForm :formIslem="gorusmebilgiler.islem" :formData="gorusmebilgiler.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="gorusmebilgiler_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                          
                             
                                      



                                </div>
                                <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl toggle-screen-xxl"
                                    data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true"
                                    data-toggle-body="true">
                                    <div class="card-inner-group" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                                        aria-label="scrollable content"
                                                        style="height: auto; overflow: hidden;">
                                                        <div class="simplebar-content" style="padding: 0px;">
                                                            <div class="card-inner">
                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-avatar lg bg-primary"> 
                                                                         <img :src="$globalVariable.uploadUrl + etkinlikler.logo"
                                                                            @error="$globalVariable.varsayilanGorsel" class="img-fluid rounded-xl">
                                                                        </div>
                                                                    <div class="user-info">
                                                                        <div
                                                                            class="badge bg-outline-light rounded-pill ucap">
                                                                            {{ etkinlikler.ad }}</div>
                                                                        <h5> {{ etkinlikler.ad  }}</h5><span
                                                                            class="sub-text">{{ etkinlikler.ad }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-inner card-inner-sm">
                                                                <ul class="btn-toolbar justify-center gx-1">
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-shield-off"></em></a>
                                                                    </li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-mail"></em></a></li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-download-cloud"></em></a>
                                                                    </li>
                                                                   
                                                                    <li><a href="#"
                                                                            class="btn btn-trigger btn-icon text-danger"><em
                                                                                class="icon ni ni-na"></em></a></li>
                                                                </ul>
                                                            </div>
                                                        
                                                            <div class="card-inner">
                                                                <div class="row text-center">
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">etkinlikler</span><span
                                                                                class="sub-text">{{ etkinlikler.ad }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">etkinlikler</span><span
                                                                                class="sub-text">{{ etkinlikler.ad }}</span>
                                                                        
                                                                    </div>
                                                                  
                                                                </div>
                                                            </div>

                                           

                                                            <div class="card-inner">
                                                                <h6 class="overline-title-alt mb-2">Kayıt Bilgileri</h6>
                                                                <div class="row g-3">
                                                                    <div class="col-6"><span class="sub-text">Oluşturma Tarihi:</span><span>{{ etkinlikler.olusturma_tarih }}</span></div>
                                                                  
                                                                    <div class="col-6"><span class="sub-text">Son Düzenleme Tarihi:</span><span>{{ etkinlikler.duzenleme_tarih }}</span></div>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: auto; height: 815px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>









            </AppMain>
        </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";

    
import firmaCard from "@/components/firmalar/firmaCard.vue";
import firmaForm from "@/components/firmalar/firmaForm.vue";
    
import kisiCard from "@/components/kisiler/kisiCard.vue";
import kisiForm from "@/components/kisiler/kisiForm.vue";
    
import gorusmebilgiCard from "@/components/gorusmebilgiler/gorusmebilgiCard.vue";
import gorusmebilgiForm from "@/components/gorusmebilgiler/gorusmebilgiForm.vue";



export default {
    name: "etkinliklerDetayView",
    components: {
        AppMain,
            
        firmaCard, 
        firmaForm,
            
        kisiCard, 
        kisiForm,
            
        gorusmebilgiCard, 
        gorusmebilgiForm,
        
    },
    data() {
        return {
            etkinlikler: [],
           
            aktifSekme: 'bilgiler',
            hareketSayfadaKayit: 10,
            hareketSeciliSayfa: 1,

            
            firmalar: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
            kisiler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
            gorusmebilgiler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
          
            


        };
    },
    mounted() {
     
        this.etkinliklerDetayGetir();
    },

    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },
     
        etkinliklerDetayGetir() {
            const id = this.$route.params.id;

            axiosCustom
                .get(`etkinlikler/detay/${id}`)
                .then((response) => {
                    this.etkinlikler = response.data;
           
                    
                    this.firmalar.tumu = response.data.firmalar;
                    this.firmalar.modal = false;
                    
                    this.kisiler.tumu = response.data.kisiler;
                    this.kisiler.modal = false;
                    
                    this.gorusmebilgiler.tumu = response.data.gorusmebilgiler;
                    this.gorusmebilgiler.modal = false;
                    

                    

                    
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },

    
        aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
            const id = this.$route.params.id;
            this.$router.push('/etkinlikler/'+id+'/'+sekme);
        },




        
        firmalarGuncelle(veriler) {
            this.firmalar = veriler;
        },
        firmalar_ekle() {
            this.firmalar.secili = {'etkinlik':this.etkinlikler.id};
            this.firmalar.islem = "ekle";
            this.firmalar.modal = true;
            this.aktifSekmeDegistir("firmalar");
        },
        firmalar_duzenle(veri) {
            this.firmalar.secili = veri;
            this.firmalar.islem = "duzenle";
            this.firmalar.modal = true;
        },
        firmalar_iptal() {
            this.firmalar.secili = {};
            this.firmalar.modal = false;
        },
        
        kisilerGuncelle(veriler) {
            this.kisiler = veriler;
        },
        kisiler_ekle() {
            this.kisiler.secili = {'etkinlik':this.etkinlikler.id};
            this.kisiler.islem = "ekle";
            this.kisiler.modal = true;
            this.aktifSekmeDegistir("kisiler");
        },
        kisiler_duzenle(veri) {
            this.kisiler.secili = veri;
            this.kisiler.islem = "duzenle";
            this.kisiler.modal = true;
        },
        kisiler_iptal() {
            this.kisiler.secili = {};
            this.kisiler.modal = false;
        },
        
        gorusmebilgilerGuncelle(veriler) {
            this.gorusmebilgiler = veriler;
        },
        gorusmebilgiler_ekle() {
            this.gorusmebilgiler.secili = {'etkinlik':this.etkinlikler.id};
            this.gorusmebilgiler.islem = "ekle";
            this.gorusmebilgiler.modal = true;
            this.aktifSekmeDegistir("gorusmebilgiler");
        },
        gorusmebilgiler_duzenle(veri) {
            this.$router.push('/gorusmeform/'+veri.id);
        },
        gorusmebilgiler_iptal() {
            this.gorusmebilgiler.secili = {};
            this.gorusmebilgiler.modal = false;
        },
        


       

        



    }
};
</script>
  

  